import { BOX_CLIENT_ID } from "@anydo/core";
import { IAnydoElectronPreload } from "@anydo/interfaces";
import { fetchSyncHttpExchangeBoxCode } from "@anydo/sync/http";

declare var AnydoElectronPreload: IAnydoElectronPreload | void;

export async function getBoxAccessToken({
  anydoAuthToken,
  signal,
}: {
  anydoAuthToken: string | null;
  signal?: AbortSignal;
}) {
  const url = `https://account.box.com/api/oauth2/authorize?${new URLSearchParams({
    client_id: BOX_CLIENT_ID,
    response_type: "code",
    redirect_uri:
      __DEV__ || typeof AnydoElectronPreload === "undefined" ?
        `${window.location.origin}/auth/box.html`
      : `anydo://localhost/auth/box.html`,
  })}`;

  const win = window.open(
    url,
    "_blank",
    "toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=600,height=600",
  );
  if (!win) {
    throw new Error("getMicrosoftAccessToken: failed to open authentication popup");
  }

  const { resolve, reject, promise } = Promise.withResolvers<string>();

  function handlePostMessage(evt: MessageEvent) {
    if (evt.source !== win) {
      return;
    }

    switch (evt.data?.type) {
      case "code":
        win?.close();
        window.removeEventListener("message", handlePostMessage);

        const code = evt.data.code;
        fetchSyncHttpExchangeBoxCode(anydoAuthToken, code).then((res) => resolve(res.access_token), reject);
        break;
    }
  }

  window.addEventListener("message", handlePostMessage, { signal });
  return promise;
}
